// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTooltip-cls1___17d11b047d7a7e6cbda{/*!*/}.UserTooltip-cls2___ef39a027f296713f035{color:#535366;margin-top:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTooltip-cls1___17d11b047d7a7e6cbda",
	"cls2": "UserTooltip-cls2___ef39a027f296713f035 UserTooltip-cls1___17d11b047d7a7e6cbda"
};
export default ___CSS_LOADER_EXPORT___;
